import api from "../utils/api";
import firebase from "firebase";
import firestore from "../firebase/firestore";

export const getPowerPlants = () => api.get("/getPowerPlants");

export const addPowerPlant = (power_plant) =>
  api.post("/addPowerPlant", power_plant);

export const addPlantsFb = (uid, plants) => {
  plants.updated_at = new Date();
  plants.created_at = new Date();
  try {
    if (uid) {
      const ref = firestore.collection("power_plants");
      return ref.doc(uid).set(plants);
    } else {
      const ref = firestore.collection("power_plants");
      return ref.add(plants);
    }
  } catch (err) {
    console.error("Erro ao adicionar a usina", err);
    return err;
  }
};

export const updatePlantsFb = (id, plants) => {
  const ref = firestore.doc(`power_plants/${id}`);
  plants.updated_at = new Date();
  return ref
    .update(plants)
    .then(() => {
      return ref.get();
    })
    .catch((err) => {
      console.error("Erro ao atualizar a usina", err);
      return err;
    });
};

export const uploadData = async ({ id, type, data }) => {
  const storageRef = firebase.storage().ref();

  if (data) {
    for (const file of data) {
      let filePath = `power_plants/${id}/${type}/${file.name}`;
      let metadata = { contentType: file.type };
      let uploadFile = storageRef.child(filePath).put(file, metadata);

      uploadFile.on(
        "state_changed",
        () => {},
        (error) => {
          console.error(error);
        },
        () => {
          uploadFile.snapshot.ref.getDownloadURL().then((downloadURL) => {
            firestore
              .collection("power_plants")
              .doc(id)
              .collection(type)
              .doc(file.name)
              .set({
                name: file.name,
                url: downloadURL,
                upload_at: new Date(),
              });
          });
        },
      );
    }
  }
};

export const uploadContract = ({ powerPlantId, status, type, file }) => {
  const storageRef = firebase.storage().ref();
  if (powerPlantId && file) {
    let filePath = `power_plants/${powerPlantId}/contracts/${file.name}`;
    let metadata = { contentType: file.type };
    let uploadFile = storageRef.child(filePath).put(file, metadata);

    return new Promise((resolve, reject) => {
      uploadFile.on(
        "state_changed",
        () => {},
        (error) => {
          console.error(error);
          reject(error);
        },
        () => {
          uploadFile.snapshot.ref
            .getDownloadURL()
            .then((downloadURL) => {
              firestore
                .collection("power_plants")
                .doc(powerPlantId)
                .collection("contracts")
                .add({
                  file_name: file.name,
                  type: type,
                  created_at: new Date(),
                  status: status,
                  url: downloadURL,
                })
                .then((ref) => {
                  resolve({
                    id: ref.id,
                    fileUrl: downloadURL,
                  });
                })
                .catch((error) => {
                  console.error(error);
                  reject(error);
                });
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            });
        },
      );
    });
  }
  return Promise.reject("Usina ou arquivo inválidos");
};

export const deleteContract = async (powerPlantId, contractId) => {
  try {
    const contractRef = firestore
      .collection("power_plants")
      .doc(powerPlantId)
      .collection("contracts")
      .doc(contractId);

    await contractRef.delete().catch((error) => {
      throw error;
    });
  } catch (error) {
    console.error("Erro ao deletar contrato:", error);
    throw error;
  }
};

export const getContracts = async (powerPlantId) => {
  try {
    const contractsSnapshot = await firestore
      .collection("power_plants")
      .doc(powerPlantId)
      .collection("contracts")
      .get();

    return contractsSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
      };
    });
  } catch (error) {
    console.error("Erro ao buscar contratos:", error);
    throw error;
  }
};

export const uploadPvsystReport = async ({ id, data, agent_email }) => {
  const storageRef = firebase.storage().ref();

  if (data) {
    for (const file of data) {
      let filePath = `power_plants/${id}/pvsyst_report/${file.name}`;
      let metadata = { contentType: file.type };
      let uploadFile = storageRef.child(filePath).put(file, metadata);
      uploadFile.on(
        "state_changed",
        () => {},
        (error) => {
          console.error(error);
        },
        () => {
          uploadFile.snapshot.ref.getDownloadURL().then((downloadURL) => {
            firestore
              .collection("power_plants")
              .doc(id)
              .collection("pvsyst_report")
              .add({
                name: "Relatório PVSyst da Usina",
                created_at: new Date(),
                url: downloadURL,
                uploaded_by: agent_email,
              });
          });
        },
      );
    }
  }
};

export const uploadDocument = async ({ id, data, agent_email }) => {
  const storageRef = firebase.storage().ref();

  if (data) {
    for (let i = 0; i < data.length; i++) {
      const file = data[i];
      let filePath = `power_plants/${id}/documents/${file.name}`;
      let uploadFile = storageRef.child(filePath).put(file.data);

      await new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (s) => {
            console.log((s.bytesTransferred / s.totalBytes) * 100 + "%");
          },
          (error) => {
            console.error(error);
            reject(error);
          },
          async () => {
            try {
              const downloadURL =
                await uploadFile.snapshot.ref.getDownloadURL();
              await firestore
                .collection("power_plants")
                .doc(id)
                .collection("documents")
                .doc(file.name)
                .set({
                  name: file.name,
                  url: downloadURL,
                  upload_at: new Date(),
                  uploaded_by: agent_email,
                });
              resolve();
            } catch (error) {
              console.error(error);
              reject(error);
            }
          },
        );
      });
    }
  }
};

export const uploadEnergyBill = async ({ id, data, agent_email }) => {
  const storageRef = firebase.storage().ref();
  if (data) {
    for (const file of data) {
      let filePath = `TotalBilling/${id}/upload_file/${file.name}`;
      let metadata = { contentType: file.data.type };
      let uploadFile = storageRef.child(filePath).put(file.data, metadata);

      await new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (s) => {
            console.log((s.bytesTransferred / s.totalBytes) * 100 + "%");
          },
          (error) => {
            console.error(error);
            reject(error);
          },
          async () => {
            try {
              const downloadURL =
                await uploadFile.snapshot.ref.getDownloadURL();
              await firestore
                .collection("TotalBilling")
                .doc(id)
                .collection("upload_file")
                .doc(file.name)
                .set({
                  name: file.name,
                  url: downloadURL,
                  upload_at: new Date(),
                  uploaded_by: agent_email,
                });
              resolve();
            } catch (error) {
              console.error(error);
              reject(error);
            }
          },
        );
      });
    }
  }
};

export const deleteDocument = async ({ id, name, url }) => {
  try {
    const documentRef = firestore
      .collection("TotalBilling")
      .doc(id)
      .collection("upload_file")
      .doc(name);
    const documentSnapshot = await documentRef.get();

    if (documentSnapshot.exists) {
      await documentRef.delete();
      const storageRef = firebase.storage().refFromURL(url);
      await storageRef.delete();
    }
  } catch (error) {
    console.error("Erro ao deletar documento:", error);
    throw error;
  }
};
